import { render, staticRenderFns } from "./HeroSection.vue?vue&type=template&id=1ba0c8e0&"
import script from "./HeroSection.vue?vue&type=script&lang=js&"
export * from "./HeroSection.vue?vue&type=script&lang=js&"
import style0 from "./HeroSection.vue?vue&type=style&index=0&id=1ba0c8e0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports